import { render, staticRenderFns } from "./home_page.vue?vue&type=template&id=4dbc1fac&"
import script from "./home_page.vue?vue&type=script&lang=js&"
export * from "./home_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports